import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Tooltip from '@material-ui/core/Tooltip'
import TuneIcon from '@material-ui/icons/Tune'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  imgLegend: {
    padding: 6,
    width: theme.spacing(5),
    position: 'absolute',
    bottom: 12,
    right: 12,
    zIndex: 1000,
    borderRadius: 12,
    backgroundColor: '#fff',
    border: '1.5px solid rgba(0,0,0,0.1)',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
  },
  swatchRamp: {
    borderRadius: 6,
    overflow: 'hidden',
  },
  small: {
    width: '100%',
  },
  customRange: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 4,
  },
}))

export default function LayerLegend({ layer, customRange = false }) {
  const classes = useStyles()
  const { t } = useTranslation()

  if (!layer?.legend?.length) return null

  return (
    <Paper className={classes.imgLegend} elevation={0}>
      <Grid container className={classes.swatchRamp}>
        {layer.legend
          ?.slice(0)
          .reverse()
          .map((l, index) => (
            <Grid key={index} item xs={12}>
              <Avatar
                variant="square"
                className={classes.small}
                style={{
                  backgroundColor: l.color,
                  fontSize: 11,
                  height: 180 / layer.legend.length,
                }}
              >
                {l.label}
              </Avatar>
            </Grid>
          ))}
      </Grid>
      {customRange && (
        <Tooltip title={t('Palette_range.custom_range')} placement="left">
          <div className={classes.customRange}>
            <TuneIcon fontSize="small" color="primary" />
          </div>
        </Tooltip>
      )}
    </Paper>
  )
}
